import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Adjustment } from '../models/adjustment';
import { AdjustmentStore } from '../service/adjustment.store';
import { VendorsTotalPaymentsSummary } from '../models/vendors-total-payments-summary';

@Injectable()
export class VendorsTotalPaymentsResolver implements Resolve<any> {
  constructor(private adjustmentStore: AdjustmentStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<VendorsTotalPaymentsSummary> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_VENDORS_TOTAL_PAYMENTS'));
    }

    if (eventPartyId) {
      return this.adjustmentStore.loadVendorsTotalPaymentsSummaryByParty(route.params[ 'id' ], eventPartyId).first();
    } else {
      return this.adjustmentStore.loadVendorsTotalPaymentsSummary(route.params[ 'id' ]).first();
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendorsTotalPayments.resolver.ts